module.exports = __webpack_public_path__ + "img/甜点蛋糕店图片生成 (1).74d63190.png";